import Menus from "pages/Restaurant/Menus";

export default function MenusPage() {
  return <Menus />;
}
